const fileManagerData = [
    {
        icon: 'assets/images/file-icons/pdf.svg',
        name: 'Invoice-project.pdf',
        date: '17-Jan-18 2:55 PM',
        size: '2.31 MB',
        users: ['assets/images/users/avatar-4.jpg', 'assets/images/users/avatar-6.jpg']
    },
    {
        icon: 'assets/images/file-icons/png.svg',
        name: 'Dashboard-design.png',
        date: '21-May-18 1:12 PM',
        size: '3.89 MB',
        users: ['assets/images/users/avatar-5.jpg']
    },
    {
        icon: 'assets/images/file-icons/psd.svg',
        name: 'Graphic-logo-main.psd',
        date: '23-May-18 11:34 AM',
        size: '125 MB',
        users: ['assets/images/users/avatar-1.jpg', 'assets/images/users/avatar-2.jpg', 'assets/images/users/avatar-3.jpg']
    },
    {
        icon: 'assets/images/file-icons/avi.svg',
        name: 'Audio-video-file.avi',
        date: '18-Feb-18 4:29 PM',
        size: '12.3 MB',
        users: ['assets/images/users/avatar-7.jpg', 'assets/images/users/avatar-8.jpg']
    },
    {
        icon: 'assets/images/file-icons/pdf.svg',
        name: 'Holiday-trip-expenses.pdf',
        date: '10-Apr-18 1:12 PM',
        size: '256 KB',
        users: ['assets/images/users/avatar-6.jpg']
    },
    {
        icon: 'assets/images/file-icons/txt.svg',
        name: 'File-changes-notes.txt',
        date: '17-Jan-18 2:55 PM',
        size: '57.3 MB',
        users: ['assets/images/users/avatar-9.jpg', 'assets/images/users/avatar-10.jpg']
    },
    {
        icon: 'assets/images/file-icons/eps.svg',
        name: 'Eps-file-formate.eps',
        date: '21-Jun-18 1:12 PM',
        size: '429 MB',
        users: ['assets/images/users/avatar-1.jpg', 'assets/images/users/avatar-2.jpg']
    },
    {
        icon: 'assets/images/file-icons/dll.svg',
        name: 'Software-activation.dll',
        date: '23-May-18 11:34 AM',
        size: '58 KB',
        users: ['assets/images/users/avatar-3.jpg']
    },
    {
        icon: 'assets/images/file-icons/sql.svg',
        name: 'Database-db.sql',
        date: '18-July-18 4:29 PM',
        size: '89.3 MB',
        users: ['assets/images/users/avatar-9.jpg', 'assets/images/users/avatar-10.jpg']
    },
    {
        icon: 'assets/images/file-icons/zip.svg',
        name: 'Minton-latest.zip',
        date: '10-Aug-18 1:12 PM',
        size: '248 MB',
        users: ['assets/images/users/avatar-4.jpg']
    },
];

export { fileManagerData };

